import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Apply from "./img/borrowers_apply.png";
import "./App.css";
import "./MarketingRebrand.css";
import HomeHeader from "./Headesr";
import NewHomepageFooter from "./NewHomepageFooter";

const Faq = () => {
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const faqs = [
    {
      id: 1,
      title: "How do I apply for a Business Loan?",
      answer: (
        <p>
          Get started by clicking on the sign up button above and it will take
          you through a step by step process to sign up for a smartlend account.
          Once you’re done with your sign up, you can head on into the dashboard
          and click on the apply loan button located on the menu bar on the
          left.
        </p>
      ),
    },
    {
      id: 2,
      title: "Can anyone apply for a Business Loan?",
      answer: (
        <p>
          Currently, only Singapore locally incorporated LLP (Limited Liability
          Partnership) or Pte. Ltd. (Private Limited) entities are eligible to
          apply for a business loan. However, if you have a different type of
          corporate entity, please reach out to us at support@smart-lend.com,
          and we'll explore how we might be able to assist you.
        </p>
      ),
    },
    {
      id: 3,
      title: "Why can’t I apply for a loan?",
      answer: (
        <p>
          If you're unable to apply for a loan, it usually means that you
          haven't synchronized your Corp Pass account with your Singpass yet.
          This synchronization process is necessary for accessing and applying
          for loans.
        </p>
      ),
    },
    {
      id: 4,
      title: "Can I speak to the lenders of the platform?",
      answer: (
        <p>
          Yes, you can speak to the lenders on our platform, but only if the
          lender has expressed interest in your loan request. In such cases, a
          chatbot request feature will be enabled on our platform. However,
          please note that we do not provide users with the private contact
          information of our lenders due to our privacy policies.
        </p>
      ),
    },
    {
      id: 5,
      title: "How can I talk to my private lender?",
      answer: (
        <p>
          If you would like to reach your lender on the loan offer that they
          have offered, you can click on the offer in the requested loan page,
          select the lender, and proceed to click on the negotiation button
          where you’ll be taken to the messaging page where you can start a
          conversation with your lender.
        </p>
      ),
    },
    {
      id: 6,
      title: "My loan has disappeared, where did it go?",
      answer: (
        <p>
          If you can't find your loan, don't worry! Once a loan is approved by
          both the borrower and lender, it is moved to the accepted loan page.
          Here, you can check the status of your loan, which will indicate the
          stage it's in before being disbursed. After your loan is disbursed, it
          will be moved to the "loan in progress" page. Here, you'll find
          detailed information about your loan and can make payments
          accordingly.
        </p>
      ),
    },
    {
      id: 7,
      title: "How long does it take for me to get a loan approved?",
      answer: (
        <div>
          <p>
            The approval time for your loan depends on several factors. First,
            you need to receive an offer from a lender. At Smart-Lend, we have a
            wide network of lenders who review your financial profile and the
            documents you've provided before making an offer. This process
            usually takes between 1 to 5 working days.
          </p>
          <p>
            Keep an eye out for our upcoming Service Guarantee feature! Soon,
            borrowers will enjoy even faster turnaround times, with approvals
            possible within 24 hours. Stay tuned for more details when we
            introduce this new feature.
          </p>
        </div>
      ),
    },
    {
      id: 8,
      title: "How long till my loan is disbursed?",
      answer: (
        <p>
          Once a loan is accepted by both the lender and borrower, it enters an
          approval stage where legal loan documents are exchanged. Once this
          process is completed, the loan can proceed to be disbursed. Once the
          offer letter is signed, usually the disbursement period will take
          within 1 or 2 working days or as fast as the day itself!
        </p>
      ),
    },
    {
      id: 9,
      title: "My Lender is not responding?",
      answer: (
        <div>
          <p>
            If you find yourself in a situation where your lender for an
            existing loan is not responding, we recommend taking action
            promptly. Please send an email to support@smart-lend.com, and we
            will intervene by reaching out to the lender on your behalf.
          </p>
          <p>
            Similarly, if a lender has offered you a loan but is unresponsive,
            don't hesitate to contact us. We are here to assist you and will
            work to resolve any issues you encounter.
          </p>
        </div>
      ),
    },
    {
      id: 10,
      title: "ZERO Fee? How can SmartLend. provide this service without a fee?",
      answer: (
        <div>
          <p>
            Yes, it's true! We do not charge borrowers any fees for loans
            initiated through our platform. We understand the challenges faced
            by SMEs, such as navigating through various stakeholders to get a
            loan approved and incurring additional costs by paying out to
            third-party brokers. By offering a comparison of loan offerings from
            different lenders, we empower SMEs to access borrowing options
            without any added fees.
          </p>
          <p>
            At SmartLend., we sustain our operations through referral fees
            received from our lenders for every initiated loan, as well as
            through advertorial fees. These fees enable us to provide our
            services to borrowers at no cost, ensuring accessibility and
            transparency in the lending process.
          </p>
        </div>
      ),
    },
    {
      id: 11,
      title: "Is my Singpass Information safe?",
      answer: (
        <p>
          Yes, all information provided through Singpass, goes through a secured
          line and is only used once upon syncing with your Singpass account.
          The information that is provided follows a strict privacy policy which
          is also stated in our privacy and policy page. As you sync with
          Singpass, you will also be able to see what are the specific
          information that will be sync with Smart-Lend providing you full
          transparency of what is happening.
        </p>
      ),
    },
    {
      id: 12,
      title: "My details in profile is incorrect.",
      answer: (
        <p>
          If your details in your profile page is incorrect, we urge you to
          ensure that your Singpass and Corppass details are up to date, as a
          way to receive credible information, we only update your profile base
          on what is provided through the authentication of your Singpass
          account. Once you have updated your Singpass and Corppass account, you
          can proceed to click on the Sync with Singpass button located on the
          top right of the Profile page.
        </p>
      ),
    },
    {
      id: 13,
      title:
        "Will submitting to multiple lenders affect my credit bureau rating?",
      answer: (
        <p>
          Submitting loan applications to multiple lenders through our platform
          will not impact your credit bureau score, except for Anext and
          Maribank. The other lenders on our platform do not perform a hard
          credit pull. Instead, you can retrieve your credit bureau report for
          free on our platform, and the same report will be shared with all the
          lenders you apply with.
        </p>
      ),
    },
    {
      id: 14,
      title:
        "I'm not comfortable letting all the lenders assess my information? Can i submit to you guys directly for assessment before submitting?",
      answer: (
        <p>
          Certainly, you can submit your information directly to us for
          assessment before applying with specific lenders. However, please note
          that we charge a success-based fee for this concierge service where we
          guide your application through the process. If you would like to
          discuss this option further, please reach out to one of our
          representatives.
        </p>
      ),
    },
    {
      id: 15,
      category: "rates",
      title: "Why do all the offers have the same interest rate and processing fee?",
      answer: (
        <div>
          <p>
            We standardize the interest rate and processing fee across every
            lender so you can compare offers fairly. Instead of competing on
            price, our lenders compete on what actually helps you — how quickly
            they fund, how much they&apos;ll lend, tenor flexibility, and
            service.
          </p>
          <p>
            Every rate also sits within the limits set by the Ministry of Law,
            so you&apos;re always protected.
          </p>
        </div>
      ),
    },
    {
      id: 16,
      category: "rates",
      title: "I've seen lower rates advertised elsewhere. Why not on SmartLend?",
      answer: (
        <div>
          <p>
            Some lenders advertise a very low rate to attract borrowers, then
            adjust it upward once you visit the branch and they review your
            documents. We don&apos;t allow that &quot;bait-and-switch&quot;
            here.
          </p>
          <p>
            On SmartLend, the rate shown is the rate the lender commits to
            honour — no surprise increases after you&apos;ve already chosen
            them. A headline rate advertised elsewhere often isn&apos;t the rate
            you actually get once fees and post-assessment changes are added in.
          </p>
        </div>
      ),
    },
    {
      id: 17,
      category: "rates",
      title: "Can the rate still change after I pick a lender?",
      answer: (
        <div>
          <p>
            The rate you see is the committed ceiling — a lender can never start
            higher than it. After you visit the branch and they complete their
            due diligence, there may be room to negotiate the rate down further.
          </p>
          <p>In other words, it only ever moves in your favour.</p>
        </div>
      ),
    },
    {
      id: 18,
      category: "rates",
      title: "If every lender charges the same, how do I choose one?",
      answer: (
        <p>
          Focus on what actually differs between offers: how fast the lender can
          disburse funds, the loan amount they&apos;re offering, tenor
          flexibility, the documents they require, and their reputation and
          service. These are the things that genuinely affect your borrowing
          experience — not a headline number.
        </p>
      ),
    },
    {
      id: 19,
      category: "rates",
      title: "Are these rates within legal limits?",
      answer: (
        <p>
          Yes. All interest rates and fees on SmartLend follow the caps set by
          the Ministry of Law — a maximum of 4% monthly interest and a
          processing fee of up to 10% of the principal. You&apos;ll never be
          quoted above the legal limit on our platform.
        </p>
      ),
    },
  ];
  const getFaqCategory = (faq) => {
    if (faq.category) return faq.category;
    const title = faq.title.toLowerCase();
    if (title.includes("lender") || title.includes("private")) return "lender";
    if (title.includes("singpass") || title.includes("profile") || title.includes("details")) return "account";
    return "borrower";
  };

  const filteredFaqs = faqs.filter((faq) => {
    const matchesSearch = faq.title
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    const matchesCategory =
      selectedCategory === "all" || getFaqCategory(faq) === selectedCategory;
    return matchesSearch && matchesCategory;
  });
  const FAQItem = ({ id, title, answer }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const handleToggle = () => {
      setIsCollapsed(!isCollapsed);
    };

    return (
      <article className={`slFaqItem ${!isCollapsed ? "slFaqItemOpen" : ""}`}>
        <button type="button" className="slFaqQuestion" onClick={handleToggle}>
          <span>{title}</span>
          <span>+</span>
        </button>
        {!isCollapsed && (
          <div className="slFaqAnswer">
            {answer}
          </div>
        )}
      </article>
    );
  };

  return (
    <div className="slMarketingPage">
      <HomeHeader />
      <main className="slMarketingShell">
        <div className="slMarketingFrame">
          <section className="slMarketingHero">
            <div className="slMarketingHeroCopy">
              <div className="slEyebrow"><span className="slEyebrowDot" />Help center</div>
              <h1>Answers for borrowers and partners, without the clutter.</h1>
              <p className="slLead">
                Search commonly asked questions about applying, offers,
                documents, lender communication, accounts, and SmartLend support.
              </p>
              <div className="slActions">
                <button className="slBtn slBtnPrimary" type="button" onClick={() => document.getElementById("faq-search")?.focus()}>
                  Search questions
                </button>
                <button className="slBtn" type="button" onClick={() => history.push("/contactus")}>
                  Contact support
                </button>
              </div>
            </div>
            <div className="slMarketingMedia">
              <img src={Apply} alt="Borrower application preview" />
              <div className="slMediaCaption">
                <b>Structured support</b>
                <p>Questions are grouped into one calm, searchable support flow.</p>
              </div>
            </div>
          </section>

          <section className="slSection">
            <div className="slFaqTools">
              <input
                id="faq-search"
                className="slSearch"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search FAQ questions..."
              />
              <div className="slChips">
                {[
                  ["all", "All"],
                  ["borrower", "Borrower"],
                  ["lender", "Lender"],
                  ["account", "Account"],
                  ["rates", "Rates"],
                ].map(([value, label]) => (
                  <button
                    key={value}
                    className={`slChip ${selectedCategory === value ? "slChipActive" : ""}`}
                    type="button"
                    onClick={() => setSelectedCategory(value)}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
            <div className="slAccordion">
              {filteredFaqs.map((faq) => (
                <FAQItem
                  key={faq.id}
                  id={faq.id}
                  title={faq.title}
                  answer={faq.answer}
                />
              ))}
            </div>
          </section>
        </div>
      </main>

      <NewHomepageFooter />
    </div>
  );
};
export default Faq;
